/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import Cookies from "js-cookie";

import {
  Form,
  Input,
  Table,
  DatePicker,
  Radio,
  Drawer,
} from "antd";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import ServiceApi from "../../../services/ServiceApi";
import ChangePath from "../../../services/ServiceApi";
// import { SubmitDynamic, GetDynamic } from "../../../actions/taskAction";

const { RangePicker } = DatePicker;

class Department extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      visible_detail: false,
      value: 1,
      title: "Department",
      data: [],
      master_data: [],
      job_id: 0,
      columns: [
        {
          title: "Department ID",
          render: (item) => (!item.department_id ? "-" : item.department_id),
          align: "center",
          key: "department_id",
          sorter: (a, b) => 
          (a.department_id === null || a.department_id  === undefined ? 0 : a.department_id) -
          (b.department_id === null || b.department_id  === undefined ? 0 : b.department_id),  
        },
        {
          title: "Department Name",
          render: (item) =>
            !item.department_name ? "-" : item.department_name,
          align: "center",
          key: "department_name",
          sorter: (a, b) => 
          (a.department_name === null || a.department_name  === undefined ? "": a.department_name).localeCompare
          (b.department_name === null || b.department_name  === undefined ? "": b.department_name),         
        },
        {
          title: "Create by",
          render: (item) => (!item.create_by ? "-" : item.create_by),
          align: "center",
          key: "create_by",
          sorter: (a, b) => 
          (a.create_by === null || a.create_by  === undefined ? 0: a.create_by) -
          (b.create_by === null || b.create_by  === undefined ? 0: b.create_by),         
        },
        {
          title: "Effective date",
          // render: (item) => (!item.effective_date ? "-" : item.effective_date),
          align: "center",
          key: "effective_date",
          render: (item) => <div>{item ? moment(item).format("DD/MM/YYYY") : "-"}</div>,
          sorter: (a, b) => 
          (a.effective_date === null || a.effective_date  === undefined ? "": a.effective_date).localeCompare
          (b.effective_date === null || b.effective_date  === undefined ? "": b.effective_date),   
        },
        {
          title: "Expired date",
          // render: (item) => (!item.expire_date ? "-" : item.expire_date),
          align: "center",
          key: "expire_date",
          render: (item) => <div>{item ? moment(item).format("DD/MM/YYYY") : "-"}</div>,
          sorter: (a, b) => 
          (a.expire_date === null || a.expire_date  === undefined ? "": a.expire_date).localeCompare
          (b.expire_date === null || b.expire_date  === undefined ? "": b.expire_date),   
        },
        {
          title: "Status",
          dataIndex: "is_active",
          align: "center",
          key: "is_active",
          sorter: () => null,
          render: (item) => (
            <div>
              {item === 0 ? (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span>InActive
                </span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
        },
        {
          title: "Action",
          dataIndex: "",
          key: "",
          sorter: () => null,
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("edit", true, item)}>
                <img src={ServiceApi.absoluteUrl("/icon/edit.svg")} />
              </a>
            </div>
          ),
        },
      ],
      filter: "",
      more_detail: false,
      form_id: null,

      active: 0,
      visibleView: false,
      dataModuleName: [],
      valueModuleName: "",
      dataTableName: [],
      valueTableName: "",
      dataMasterLanguage: [],
      valueMasterLanguage: [
        { children: ["English", " (", "EN", ")"], key: "EN", value: "English" },
      ],
      rulesOpt: [],
      disOpt: [],
      disBtn: true,
      disInput: true,
      dataColumnName: [],
      dataMasFormJson_Call: {},
      mode: "add",
      dataAdd: {
        condition: [{ key: 0, fieldKey: 0, name: 0 }],
        forms: [{ key: 0, fieldKey: 0, name: 0 }],
        language: ["English"],
      },
      data_dynamic_from: [],
      department_id: 0,
      id_form: 0,
      data_dynamic: [],
    };
  }

  async componentDidMount() {
    const data = await ServiceApi.post("get_department", {
      "pk_id":          null,
      "is_active":      1,
      "effective" :     null , 
      "sql_where" :     "" ,
      "department_id":  null ,
      "company_id":     Cookies.get("companyid"),
      "operator_id":    Cookies.get("operator_id"),
      "project_id" :    Cookies.get("project_id"),
    });
    //console.log(data,'get_department data');

    // const data_from_dynamic = await ServiceApi.get(
    //   "get_list_mas_form_json",
    //   "department"
    // );


    if (data.data.result.code === "P") {
      this.setState({
        // data: data.data.data.department_dto_list,
        filteredData: data.data.data,
        master_data: data.data.data,
        loading: false,
      });
    } 

    // if(data_from_dynamic.data.result.code === "P"){
    //   this.setState({
    //     data_dynamic_from: data_from_dynamic.data.data.mas_form_json_dto_list,
    //   });
    // }

    // this.setState({
    // });

  }

  async handleSubmit(values, obj) {
    const {mode} = this.state;
    if (obj === "moredetail") {
    } else {
      const UpdateDepartment = await ServiceApi.post("v2/update_department", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        department_id: this.state.department_id,
        is_active: mode === "add"? 1 : values.is_active,
        department_name: values.department_name,
        create_date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        effective_date: moment(values.date[0]).format("YYYY-MM-DD HH:mm"),
        expire_date: moment(values.date[1]).format("YYYY-MM-DD HH:mm"),
        create_by: Cookies.get("username"),
        form_id: this.state.id_form,
        data_dynamic: [],
      });
      if (UpdateDepartment.data.result.value === "P") {
        alert("Success");
        this.setState({ visible: false });
        const data = await ServiceApi.post("get_department", {
          "pk_id":          null,
          "is_active":      1,
          "effective" :     null , 
          "sql_where" :     "" ,
          "department_id":  null ,
          "company_id":     Cookies.get("companyid"),
          "operator_id":    Cookies.get("operator_id"),
          "project_id" :    Cookies.get("project_id"),
        });
        if (data.data.result.code === "P") {
          this.setState({
            // data: data.data.data.department_dto_list,
            filteredData: data.data.data,
            master_data: data.data.data,
            loading: false,
          });
        } 
      } else {
        alert("Update Error");
      }
    }
  }

  Search = (value) => {
    console.log(value);
    const {master_data} = this.state;
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data.length; i++) {
              for (const [key, value] of Object.entries(master_data[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = "-"
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );

      this.setState({
        filteredData: filter_table
      })
    } else {
      this.setState({
        filteredData: master_data
    })
    }
  }

  async onModal(mode, visible, item) {
    if (visible === false) {
      this.formRef.current.resetFields();
      this.setState({ visible: visible });
    } else {
      await this.setState({
        mode: mode,
        visible: visible,
      });
      if (mode === "edit") {
        var form = await item;
        this.setState({
          job_id: form.job_category_id,
          form_id: form.form_id,
        });
        var effective =  moment(new Date(form.effective_date));
        var expire =  moment(new Date(form.expire_date));
        this.formRef.current.setFieldsValue({
          job_category_name: form.job_category_name,
          department_name: form.department_name,
          date: [effective, expire],
          is_active: form.is_active,
        });
        await this.setState({
          department_id: item.department_id,
        });
      } else if (mode === "add"){
        this.formRef.current.resetFields();
      }
    }
    // console.log("item");
    // console.log(item);

  }

  setConditions(data) {
    let option = data.split(",");
    let options = [];
    for (let i = 0; i < option.length; i++) {
      let _option = option[i].split("=");
      options.push({
        column_name: _option[0],
        value: _option[1],
      });
    }
    return options;
  }

  setFormsView(data) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      form_json.push(form_json_parse[data["table_name"]][x]);
    }
    return form_json;
  }

  async onMoreDetail() {
    var from_jsob = [];
    var posetion_from = 0;
    var check_from = 0;
    await this.setState({
      data_dynamic: [],
      dataMasFormJson_Call: {},
    })
    const values = this.formRef.current.getFieldsValue();

    if (values.department_name != undefined) {
      if (values.department_name === "Digital") {
        posetion_from = 0;
      }
      if (values.department_name === "Nationwide") {
        posetion_from = 1;
      }
      if (values.department_name.includes("Department") === true) {
        posetion_from = 2;
      }
      if (
        values.department_name === "Digital" ||
        values.department_name === "Nationwide" ||
        values.department_name.includes("Department") === true
      ) {
        check_from = 0;
      } else {
        check_from = 1;
      }
    } else {
      check_from = 1;
    }
    const data_dynamic = {
      form_id: null,
      table_name: "department",
      division_id: 0,
      department_name: values.department_name,
      department_id: this.state.department_id,
    };

    if (check_from === 0) {
      const dataMasFormJson = this.state.data_dynamic_from[posetion_from];
      if ( dataMasFormJson["expire_date"] !== "" && dataMasFormJson["expire_date"] !== null) {
        dataMasFormJson["expire_date"] = moment( dataMasFormJson["expire_date"], "YYYY/MM/DD");
      }
      dataMasFormJson["condition"] = this.setConditions(dataMasFormJson["data_roles"]);
      
      dataMasFormJson["forms"] = this.setFormsView(dataMasFormJson);
      if(typeof  dataMasFormJson["language_name"] === "string" && typeof  dataMasFormJson["language"] === "string"){
        dataMasFormJson["language_name"] = dataMasFormJson["language_name"].split(",");
        dataMasFormJson["language"] = dataMasFormJson["language"].split(",");
      }
      await this.setState(
        {
          dataMasFormJson_Call: dataMasFormJson,
        },
        () => {
          this.setState({ visible_detail: false });
        }
      );
    } else {
      await this.setState({
        visibleView: true,
      });
    }
    await this.setState({
      data_dynamic: data_dynamic,
      more_detail: true,
      visible_detail: true,
      id_form: posetion_from,
    });
  }

  onCancel(name) {
    if (name === "visible_detail") {
      this.formRef.current.resetFields();
      this.setState({
        visible_detail: false,
        visible_detail: false,
        dataMasFormJson_Call: {},
        more_detail: false,
      });
      var showdata = Api.CallBack(null, "cancel");
    }
    if (name === "visible") {
      this.formRef.current.resetFields();
      this.setState({
        visible: false,
        visible_detail: false,
        dataMasFormJson_Call: {},
        more_detail: false,
      });
      var showdata = Api.CallBack(null, "cancel");
    }
  }

  renderDrawer() {
    const {
      title,
      mode,
      loading,
      visible,
      data_dynamic,
      more_detail,
    } = this.state;
    return (
      <Drawer
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} {title}
          </span>
        }
        placement="right"
        closable={false}
        onClose={this.onClose}
        visible={visible}
        width={420}
      >
        {/* <Spin spinning={loading}> */}
        <Form
          onFinish={(mode, values) => this.handleSubmit(mode, values)}
          layout="vertical"
          ref={this.formRef}
        >
          {mode == "edit" ? (
            <Form.Item
              name="is_active"
              label="Status"
              rules={[{ required: true, message: "Status is required" }]}
            >
              <Radio.Group>
                <Radio value={1}>
                  <span className="font-thai-r fs-18">Active</span>
                </Radio>
                <Radio value={0}>
                  <span className="font-thai-r fs-18">Inactive</span>
                </Radio>
              </Radio.Group>
            </Form.Item>
          ) : null}

          <Form.Item
            name="department_name"
            label="Department Name"
            rules={[{ required: true, message: "Division name is required" }]}
          >
            <Input
              className="font-mont-r fs-12"
              type="text"
              size="large"
              placeholder="Please Input"
            />
          </Form.Item>
          <Form.Item
            name="date"
            label="Effective - Expire Date"
            rules={[
              {
                required: true,
                message: "Effective - expire date is required",
              },
            ]}
          >
            <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
          </Form.Item>

          {/* <Form.Item>
            <button
              type="button"
              className="c-blue text-underline"
              onClick={() => this.onMoreDetail()}
            >
              More detail
            </button>
          </Form.Item> */}

          {/* {more_detail === true ? (
            <DynamicForm obj={this.state.dataMasFormJson_Call} />
          ) : null} */}
          {/* <Ui.GenDynamic data={data_dynamic} />  */}
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.onCancel("visible")}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">{mode}</button>
          </Form.Item>
        </Form>
        {/* </Spin> */}
      </Drawer>
    );
  }
  render() {
    const { title, columns, filter, filteredData } = this.state;
    return (
      <div>
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>
        <div className="d-flex justify-content-between my-3">
          <Input.Search
            placeholder="Search department name"
            allowClear
            onSearch={this.Search}
            style={{ width: 200 }}
          />
          <button
            className="btn btn-warning"
            onClick={() => this.onModal("add", true )}
          >
            <img
              src={ChangePath.absoluteUrl("/icon/plus.svg")}
              className="mr-2"
            />
            Add {title}
          </button>
        </div>
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="department_id"
        />
        {this.renderDrawer()}
        {/* {this.renderDetail()} */}
      </div>
    );
  }
}

export default Department;
// const mapStateToProps = (state) => (
//   console.log( state.task_dynamic.get_data_dispatch)
// //   {
// //   get_data_dispatch: state.task_dynamic.get_data_dispatch,
// // }
// );

// const mapDispacthToProps = (dispatch) => {
//   return {
//     GetDynamic: () => dispatch(GetDynamic()),
//   };
// };

// export default connect( mapDispacthToProps , mapStateToProps)(Department);
